import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import pb, { redirectUrl } from "../../../lib/pocketbase"
import { useLocalStorage } from "../../../Utils"

const Auth = props => {
    const [provider] = useLocalStorage("provider", {})
    const [resultData, setResultData] = useState("")
    const [params] = useSearchParams()

    useEffect(() => {
        if (provider.state !== params.get("state")) {
            setResultData("State parameters don't match.")
            return
        }

        pb.collection("users")
            .authWithOAuth2(
                provider.name,
                params.get("code"),
                provider.codeVerifier,
                redirectUrl,
                // pass optional user create data
                {
                    emailVisibility: false,
                }
            )
            .then(authData => {
                let avatarUrl = authData?.meta?.avatarUrl ?? ""
                pb.collection("users")
                    .update(authData.record.id, { avatarUrl })
                    .then(() => {
                        window.location.href = "index.html"
                    })
            })
            .catch(err => {
                setResultData("Failed to exchange code.\n" + err)
            })
    }, [params, provider])
    return resultData
}

export default Auth
